import { render } from "./FeedbackToolbar.vue?vue&type=template&id=43b70883"
import script from "./FeedbackToolbar.vue?vue&type=script&lang=js"
export * from "./FeedbackToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__